module.exports = __webpack_public_path__ + "img/Glaube_Fuer_Anfaenger_Cover.44b5f915.jpg";